
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Navimumbaiairporttogoacab() {



const cardData = {
  keyword: "Navi Mumbai Airport to Goa Cabs",
  heading: "Skyline Cabs: Navi Mumbai Airport to Goa Cabs",
  headingDescription: "Skyline Cabs provides premium Navi Mumbai Airport to Goa Cabs for long-distance coastal travel with complete comfort, safety, and reliability. Whether you are landing at Navi Mumbai Airport or planning a direct departure from Mumbai, our well-maintained fleet ensures smooth highway performance across the Mumbai–Goa route. With professional drivers experienced in Konkan highways, transparent pricing, and flexible one-way and round-trip options, we make your Goa journey stress-free. Choose from sedan, SUV, Innova Crysta, or luxury vehicles and enjoy a comfortable road trip experience with Skyline Cabs.",

  top: "Top Places to Visit in Goa with Skyline Cabs",

  topPlaces: [
    {
      title: "Baga Beach",
      description: "Baga Beach is one of the most vibrant and lively beaches in North Goa, famous for water sports, nightlife, beach shacks, and sunset views. Travelers from Mumbai and Navi Mumbai often plan road trips to Baga Beach for weekend relaxation and party experiences. The long coastal highway journey becomes comfortable with Navi Mumbai Airport to Goa cab service offering smooth sedan and SUV travel. Baga is ideal for jet skiing, parasailing, banana boat rides, and enjoying seafood delicacies at beachside restaurants. Evening time offers electrifying nightlife at Tito’s Lane and surrounding clubs. Skyline Cabs ensures safe drop and pickup, making your Goa beach vacation comfortable and memorable."
    },
    {
      title: "Calangute Beach",
      description: "Calangute Beach, often called the ‘Queen of Beaches,’ attracts thousands of visitors every year for its scenic coastline and vibrant environment. Families and couples traveling from Mumbai to Goa cab service frequently include Calangute in their itinerary. The wide sandy stretch and organized water sports facilities make it perfect for full-day relaxation. Visitors enjoy local Goan cuisine, shopping stalls, and peaceful sunset walks. With Navi Mumbai Airport to Goa cabs, travelers can reach Calangute comfortably after a long yet scenic highway drive."
    },
    {
      title: "Fort Aguada",
      description: "Fort Aguada is a 17th-century Portuguese fort offering panoramic Arabian Sea views and historical architecture. Located near Sinquerim Beach, it is a must-visit heritage site for history lovers. Many travelers booking Mumbai to Goa cab price options choose Fort Aguada as their first sightseeing stop. The lighthouse and coastal landscape provide excellent photography opportunities. Skyline Cabs ensures smooth access to this elevated location through experienced drivers familiar with Goa routes."
    },
    {
      title: "Dudhsagar Waterfalls",
      description: "Dudhsagar Waterfalls is one of India’s tallest waterfalls located on the Goa–Karnataka border. Tourists traveling via Mumbai airport to Goa cab often plan a visit to this breathtaking natural attraction. Surrounded by dense forest and railway bridges, the waterfall offers adventure trekking and jeep safari experiences. The comfortable long-distance journey with Navi Mumbai Airport to Goa cabs ensures relaxed travel before reaching this scenic location."
    },
    {
      title: "Basilica of Bom Jesus",
      description: "The Basilica of Bom Jesus in Old Goa is a UNESCO World Heritage Site known for its baroque architecture and religious significance. Travelers booking Mumbai to Goa cab booking services frequently explore this historic church. It houses the mortal remains of St. Francis Xavier and attracts pilgrims from across the world. Skyline Cabs offers comfortable transportation for families and senior travelers visiting this spiritual landmark."
    },
    {
      title: "Anjuna Beach",
      description: "Anjuna Beach is famous for its flea markets, vibrant nightlife, and laid-back atmosphere. Visitors driving from Navi Mumbai Airport to Goa cab service enjoy the scenic route before relaxing at Anjuna. The beach is known for music festivals and cliffside sunset views. Skyline Cabs ensures comfortable arrival after the long Mumbai–Goa road journey."
    },
    {
      title: "Colva Beach",
      description: "Colva Beach in South Goa is known for its peaceful surroundings and white sand coastline. It is perfect for families seeking relaxation away from crowded beaches. Booking Mumbai to Goa taxi one way fare allows convenient travel planning for extended South Goa stays."
    },
    {
      title: "Chapora Fort",
      description: "Chapora Fort offers stunning views of Vagator Beach and surrounding hills. Many travelers booking Mumbai to Goa by car fare include this iconic spot for sunset photography. The fort gained popularity due to Bollywood films and remains a tourist favorite."
    },
    {
      title: "Miramar Beach",
      description: "Miramar Beach near Panaji offers calm waters and scenic coastal views ideal for peaceful evenings. Travelers using Navi Mumbai Airport to Goa cabs often visit Miramar for its accessibility and serene ambiance."
    },
    {
      title: "Palolem Beach",
      description: "Palolem Beach in South Goa is known for its crescent-shaped coastline and peaceful retreat atmosphere. Long-distance travelers booking Mumbai to Goa cab service often extend their trip to explore this scenic paradise. Skyline Cabs ensures safe return journeys as well."
    }
  ],

  services: [
    {
      name: "mumbai to goa cab",
      description: "Skyline Cabs provides reliable mumbai to goa cab service designed for long-distance highway comfort and safety. Our vehicles are maintained for extended travel with strong suspension, powerful AC, and comfortable seating. Drivers are experienced in the Mumbai–Goa highway route ensuring smooth navigation through Konkan ghats. Whether planning a family vacation or group outing, our cab service ensures flexible scheduling, luggage capacity, and transparent pricing."
    },
    {
      name: "mumbai to goa taxi fare",
      description: "Get transparent mumbai to goa taxi fare details with no hidden charges. Our pricing includes driver allowance, fuel cost, and toll guidance. Customers can choose sedan, SUV, or Innova Crysta based on budget and comfort preferences."
    },
    {
      name: "mumbai to goa taxi",
      description: "Book mumbai to goa taxi for convenient one-way or round-trip travel. Skyline Cabs ensures highway safety, regular vehicle checks, and punctual service."
    },
    {
      name: "mumbai to goa cab fare",
      description: "We offer competitive mumbai to goa cab fare packages suitable for families and corporate travelers. Fare breakdown remains transparent with flexible pickup scheduling."
    },
    {
      name: "mumbai to goa taxi one way fare",
      description: "Choose mumbai to goa taxi one way fare option for budget-friendly travel without return cost obligations."
    },
    {
      name: "mumbai to goa cab price",
      description: "Our mumbai to goa cab price structure is clear and competitive with vehicle-based pricing models."
    },
    {
      name: "mumbai to goa by car fare",
      description: "Calculate accurate mumbai to goa by car fare with Skyline Cabs for comfortable road trips."
    },
    {
      name: "mumbai airport to goa cab",
      description: "Timely mumbai airport to goa cab pickup with flight tracking and smooth departure planning."
    },
    {
      name: "mumbai goa cab service",
      description: "Professional mumbai goa cab service for safe, reliable intercity travel."
    },
    {
      name: "mumbai to goa cab booking",
      description: "Easy online mumbai to goa cab booking with instant confirmation."
    },
    {
      name: "mumbai to goa cab charges",
      description: "Transparent mumbai to goa cab charges with clear fare inclusions."
    },
    {
      name: "mumbai to goa cab service",
      description: "Trusted mumbai to goa cab service offering flexible travel packages."
    },
    {
      name: "mumbai to goa car hire",
      description: "Comfortable mumbai to goa car hire with experienced chauffeurs."
    },
    {
      name: "mumbai to goa taxi price",
      description: "Affordable mumbai to goa taxi price options with multiple vehicle categories."
    },
    {
      name: "navi mumbai airport to goa cabs",
      description: "Premium navi mumbai airport to goa cabs for direct airport pickup and comfortable highway travel."
    },
    {
      name: "navi mumbai airport to goa cab",
      description: "Reliable navi mumbai airport to goa cab service with punctual pickup and safe long-distance travel."
    }
  ],

  tableData: [
    ["mumbai to goa cab", "mumbai to goa taxi fare"],
    ["mumbai to goa taxi", "mumbai to goa cab fare"],
    ["mumbai to goa taxi one way fare", "mumbai to goa cab price"],
    ["mumbai to goa by car fare", "mumbai airport to goa cab"],
    ["mumbai goa cab service", "mumbai to goa cab booking"],
    ["mumbai to goa cab charges", "mumbai to goa cab service"],
    ["mumbai to goa car hire", "mumbai to goa taxi price"],
    ["navi mumbai airport to goa cabs", "navi mumbai airport to goa cab"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Highway Expertise & Safety",
      WhyChoosedescription: "Our drivers are experienced in long-distance Mumbai–Goa highway travel, ensuring safe ghat navigation, smooth driving, and punctual arrival."
    },
    {
      WhyChooseheading: "Transparent Fare Structure",
      WhyChoosedescription: "Clear fare breakdown including toll guidance, driver charges, and flexible vehicle options."
    },
    {
      WhyChooseheading: "Comfortable Long-Distance Vehicles",
      WhyChoosedescription: "Well-maintained sedans and SUVs with strong air conditioning and luggage capacity."
    },
    {
      WhyChooseheading: "24x7 Booking Support",
      WhyChoosedescription: "Round-the-clock availability for airport and early morning departures."
    },
    {
      WhyChooseheading: "Flexible One-Way & Round Trip Options",
      WhyChoosedescription: "Choose cost-effective one-way travel or extended round-trip packages."
    },
    {
      WhyChooseheading: "Professional Chauffeurs",
      WhyChoosedescription: "Trained and verified drivers ensure smooth highway experience."
    },
    {
      WhyChooseheading: "Sanitized & Clean Vehicles",
      WhyChoosedescription: "Hygienic interiors maintained for long journeys."
    },
    {
      WhyChooseheading: "Customer-Focused Service",
      WhyChoosedescription: "Dedicated support team ensures smooth booking and trip management."
    }
  ]
}


const faqData = [
    {
        id: 1,
        question: 'How can I book Navi Mumbai Airport to Goa Cabs with Skyline Cabs?',
        answer:
            'Booking Navi Mumbai Airport to Goa Cabs with Skyline Cabs is simple and convenient. Visit our website or mobile app, select Navi Mumbai Airport as your pickup location and Goa as your drop destination, choose your preferred vehicle, and confirm instantly. You will receive booking confirmation along with driver and vehicle details for a smooth travel experience.',
    },
    {
        id: 2,
        question: 'Is Navi Mumbai Airport to Goa Cab service available 24/7?',
        answer:
            'Yes, Skyline Cabs offers 24/7 Navi Mumbai Airport to Goa Cab service. Whether your flight lands late at night or early in the morning, we ensure timely pickup from the airport and comfortable long-distance travel to Goa.',
    },
    {
        id: 3,
        question: 'What vehicle options are available for Navi Mumbai Airport to Goa Cabs?',
        answer:
            'We provide multiple vehicle options including Swift Dzire, Ertiga, Innova Crysta, and other premium SUVs. Our Navi Mumbai Airport to Goa Cabs are suitable for solo travelers, families, and group trips with ample luggage space and comfort.',
    },
    {
        id: 4,
        question: 'How much is the Navi Mumbai Airport to Goa Cab fare?',
        answer:
            'The Navi Mumbai Airport to Goa Cab fare depends on the vehicle type and whether you choose one-way or round-trip travel. Skyline Cabs provides competitive and transparent pricing that includes toll charges and driver allowance with no hidden costs.',
    },
    {
        id: 5,
        question: 'Is one-way Navi Mumbai Airport to Goa Cab available?',
        answer:
            'Yes, Skyline Cabs offers affordable one-way Navi Mumbai Airport to Goa Cab service. You only pay for the distance traveled without return fare charges, making it cost-effective for single-direction travel.',
    },
    {
        id: 6,
        question: 'How long does it take to travel from Navi Mumbai Airport to Goa by cab?',
        answer:
            'The journey from Navi Mumbai Airport to Goa typically takes around 9 to 11 hours depending on traffic and road conditions. Our experienced drivers ensure safe highway driving and comfortable long-distance travel.',
    },
    {
        id: 7,
        question: 'Are online payments available for booking?',
        answer:
            'Yes, Skyline Cabs supports secure online payments via UPI, credit cards, debit cards, and net banking. You receive instant booking confirmation after successful payment.',
    },
    {
        id: 8,
        question: 'Can I pre-book Navi Mumbai Airport to Goa Cabs?',
        answer:
            'Absolutely. You can pre-book your Navi Mumbai Airport to Goa Cab in advance for weekends, holidays, and peak travel seasons. Advance booking ensures guaranteed availability and smooth travel planning.',
    },
    {
        id: 9,
        question: 'Is Navi Mumbai Airport to Goa Cab suitable for family trips?',
        answer:
            'Yes, our spacious vehicles like Ertiga and Innova Crysta are ideal for family travel. With comfortable seating, powerful AC, and luggage space, Skyline Cabs ensures a relaxed journey to Goa.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Navi Mumbai Airport to Goa Cabs?',
        answer:
            'Skyline Cabs is trusted for Navi Mumbai Airport to Goa Cabs because of our professional chauffeurs, clean vehicles, transparent pricing, punctual airport pickup, and 24x7 customer support. We ensure a safe, comfortable, and stress-free journey from the airport to your Goa destination.',
    },
];

const someReviews = [
    {
        name: "Mr. Kunal Verma",
        rating: 5,
        review: "Booked Navi Mumbai Airport to Goa Cab with Skyline Cabs after landing at midnight. Driver was waiting on time and the journey was smooth and comfortable. Excellent long-distance service!"
    },
    {
        name: "Mrs. Anjali Patil",
        rating: 4,
        review: "Very reliable Navi Mumbai Airport to Goa Cab service. Clean car, polite driver, and transparent pricing. Skyline Cabs made our Goa trip comfortable and stress-free."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Airport to Goa Cabs",
  "image": "https://skylinecabs.com/assets/images/navi-mumbai-to-goa-cab.jpg",
  "description": "Book Navi Mumbai Airport to Goa Cabs with Skyline Cabs for safe and comfortable long-distance travel. One way and round trip taxi service available with sedan, SUV, and Innova cars driven by professional drivers at affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8499",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/navi-mumbai-airport-to-goa-cabs"
  }
};


      


    return (
        <div>

<Helmet>
  <title>Navi Mumbai Airport to Goa Cabs | One Way & Round Trip Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Navi Mumbai Airport to Goa Cabs with Skyline Cabs for safe, comfortable, and reliable travel. Affordable one way and round trip taxi service with professional drivers available 24x7." 
  />
  <meta 
    name="keywords" 
    content="mumbai to goa cab, mumbai to goa taxi fare, mumbai to goa taxi, mumbai to goa cab fare, mumbai to goa taxi one way fare, mumbai to goa cab price, mumbai to goa by car fare, mumbai airport to goa cab, mumbai goa cab service, mumbai to goa cab booking, mumbai to goa cab charges, mumbai to goa cab service, mumbai to goa car hire, mumbai to goa taxi price, navi mumbai airport to goa cabs, navi mumbai airport to goa cab, navi mumbai airport to goa taxi, cab from navi mumbai airport to goa, taxi from navi mumbai airport to goa, book cab navi mumbai airport to goa, online cab booking navi mumbai airport to goa, best cab navi mumbai airport to goa, cheapest cab navi mumbai airport to goa, Skyline Cabs Navi Mumbai Airport to Goa" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
    

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/129.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Navimumbaiairporttogoacab;